import { isObject } from "../../utilities";

// This is not truly a reducer, but can be used if you just want state information "echoed" back to you for your consumption.
export const echoReducer = (state, action) => {
    // Update state overriding any older values with the latest one
    if (isObject(action) && isObject(action.payload)) {
        return { ...state, ...action.payload };
    }
    return state;
};
